<template>
  <b-modal :id="modalId"
           @hide="clearData">
    <template slot="modal-header">
      <h4 v-if="!registrationFinished">Register Agent</h4>
      <h4 v-else>Thank you</h4>
    </template>

    <form v-if="!registrationFinished" @submit.prevent>
      <div class="container-fluid">
        <p>To register the Agent with RBM, you must select a region.</p>

        <div class="row form-group">
          <div class="col-8">
            <form-select id="mode"
                         label="Region"
                         :value="selectedRegion"
                         inputClasses="col-8"
                         @form-select="selectedRegion = $event">
              >
              <option slot="options" v-for="value in regions" :value="value" :key="value">
                {{ value | rbmRegion }}
              </option>
            </form-select>
          </div>
        </div>

        <div class="alert alert-warning" role="alert">
          <icon class="btn-icon" name="exclamation-triangle"></icon>
          You won't be able to change <b>Region</b> later.
        </div>
      </div>
    </form>

    <template v-if="registrationFinished">
      <p>Request for registration has been submitted and should be resolved <b>within 24 hours</b>.</p>
    </template>

    <template slot="modal-footer">
      <button class="btn btn-secondary"
              type="button"
              @click="hideModal">Close
      </button>

      <button v-if="!registrationFinished"
              class="mr-0 btn btn-success"
              :disabled="isUpdateDisabled()"
              type="button"
              @click="promiseCreateAgent = handleCreateAgent()"
              v-busy-button="promiseCreateAgent">
        <icon class="btn-icon" name="plus-circle"></icon>
        Register Agent
      </button>
    </template>
  </b-modal>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import FormSelect from '@/components/administration/common/form/FormSelect'
  import eventBus from '@/services/event-bus/event-bus'
  import enums from '@/common/enums'

  const regions = enums.platforms.rbm.regions

  export default {
    components: {
      FormSelect
    },

    props: {
      modalId: {
        type: String,
        required: true
      },
      channelId: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        promiseCreateAgent: null,
        regions,
        selectedRegion: null,
        registrationFinished: false
      }
    },

    methods: {
      isUpdateDisabled() {
        return this.selectedRegion === null
      },

      hideModal() {
        this.clearData()
        this.$root.$emit('bv::hide::modal', this.modalId)
      },

      clearData() {
        this.selectedRegion = null
        this.clearPromise()
      },

      clearPromise() {
        this.promiseCreateAgent = null
      },

      handleCreateAgent() {
        return channelService.patch(this.channelId, {
          rbm: {
            region: this.selectedRegion,
            agent_state: this.$enums.platforms.rbm.agentStates.createRequested
          }
        })
          .then(response => {
            eventBus.$emit('update-channel', response.data)
          })
          .then(() => { this.registrationFinished = true })
          .catch(error => {
            if (error.response.status !== 422) return

            log.debug('RBM agent update failed with error:', error)
            this.errors = error.response.data.errors
          })
          .then(this.clearPromise)
      }
    }
  }
</script>
